						
const $ = require('jquery');
import run from '../../../utilities/run';
import {isPresent} from "../../../utilities/general";
import {setSwitchery,instantiateSwitchery,enableSwitchery,disableSwitchery,setSwitcheryWithoutChange} from '../../../utilities/instantiateSwitchery';
import {bindHardSubmit} from "../../../utilities/submitHelpers";
import {quickFileUploader} from "../../../components/QuickFileUploader/QuickFileUploader";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../../constants";
import QuickBtnGroup from "../../../components/QuickBtnGroup/QuickBtnGroup";
import { setOptionsForSelect } from "../../../utilities/selectorHelpers";
// const targetSelector = "#p_p_id_rmsui_WAR_rmsuiportlet_";
const targetSelector = ".merchant-config-outer";


run(targetSelector, (outerEl)=>{
  attachPages(outerEl);
});

function attachPages(outerEl){

  const fileUploaderEl = outerEl.find(".logo-uploader");
  const colorPickerLink = outerEl.find(".color-picker-link");
  const swatchInput = outerEl.find("#sc-swatch-input");
  const swatchEl = outerEl.find(".mc-swatch");
  const bannerEl = outerEl.find(".mc-banner-preview");
  const retailerBannerConfigSection = outerEl.find('.retailer-banner-config');
  const retailerBannerPreview = outerEl.find('.mc-banner-example');
  const scRmaService = outerEl.find('.sc-rma-service');
  //HB-11879 START

  const sgrPrefixPredefined = outerEl.find('.sgr-prefix-predefined');
  const sgrPrefix = outerEl.find('#sgr-prefix');
  const customRmaPrefixField  = outerEl.find('.custom-rma-prefix');
  const customRmaPredefinedField  = outerEl.find('.predefined-rma-prefix');
  const customBtn = $(".custom-btn");
	const predefinedBtn = $(".predefined-btn");

	const customBtnValueCheck = $("#custom-btn-value-check");
  const predefinedBtnValueCheck = $("#predefined-btn-value-check");
  //deactivateBtns();
  //HB-11879 END
  const scShippingService = outerEl.find('.sc-shipping-service');
  const serviceConfigSaveBtn = outerEl.find(".save-service-config-edits");
  const serviceConfiguration = outerEl.data("service-configuration-uri");
  const systemGeneratedRmaConfig = outerEl.find('.if-system-generated-rma');
  const retailerSuppliedRmaConfig = outerEl.find('.if-retailer-supplied-rma');
  const startNumberLength = outerEl.find("#sgr-number-length");

  const currentEntityNumber = outerEl.data('current-rma-number');
  const generateAuthTokenBtn = outerEl.find("#get-ext-auth-token");
  const generateHCAuthTokenBtn = outerEl.find("#get-ext-auth-token-hc");
  const accessTokenVal = outerEl.find("#accessToken");
  const loadAuthTokenBtn = outerEl.find("#load-auth-token");
  const regenerateAuthTokenBtn = outerEl.find("#reget-ext-auth-token");
  const regenerateHCAuthTokenBtn = outerEl.find("#reget-ext-auth-token-hc");
  const copyTokenBtn = outerEl.find("#copy-auth-token");
  const authFailedMsg = outerEl.find("#auth-failed");
  const addAnthChannelBtn = outerEl.find("#add-another-channel");
  const duplicateTokenAuthDiv = outerEl.find(".channel-token-auth-div");
  const channelEmptyMsg = outerEl.find("#channel-empty");
  const returnChannelName = outerEl.find("#returnChannelName");
  const accessTokenDisplayDiv = outerEl.find(".acess-token-display-div");
  const rmsAuthTokenAvl = outerEl.find('#rms-auth-token-avl');
  const hcAuthTokenAvl = outerEl.find('#hc-auth-token-avl');

  const retailerReturnsConfiguration =  outerEl.data("retailer-returns-configuration");

  const orderNumberVisible = outerEl.find(".prp-order-number-visible");
  const orderNumberMandatory =  outerEl.find(".prp-order-number-mandatory");
  const orderNumberMandatoryDiv = outerEl.find(".prp-order-number-mandatory-div");

  //E-67370 
  const rmaLiteReturnReasonField = outerEl.find(".pgp-show-rma-lite-return-reason");
  const rmaLiteAllowMultipleLabels = outerEl.find("#pgp-allow-multiple-labels");
  const rmaLiteMaxNumberOfLabels = outerEl.find("#pgp-max-labels-allowed");

  const maxLabelsAllowed = outerEl.find(".max-labels-alwd");
  
  //showFieldSwitchery
  const referenceShowFieldSwitchery = outerEl.find(".reference-show-field-switchery");
  const departmentShowFieldSwitchery = outerEl.find(".department-show-field-switchery");
  const poShowFieldSwitchery = outerEl.find(".po-show-field-switchery");
  const invoiceShowFieldSwitchery = outerEl.find(".invoice-show-field-switchery");

  //requiredFieldSwitchery
  const referenceRequiredFieldSwitchery = outerEl.find(".reference-required-field-switchery");
  const departmentRequiredFieldSwitchery = outerEl.find(".department-required-field-switchery");
  const poRequiredFieldSwitchery = outerEl.find(".po-required-field-switchery");
  const invoiceRequiredFieldSwitchery = outerEl.find(".invoice-required-field-switchery");
  
  //toggleTargets  
  const referenceConfigToggleTarget = outerEl.find(".reference-config-toggle-target");
  const departmentConfigToggleTarget = outerEl.find(".department-config-toggle-target");
  const poConfigToggleTarget = outerEl.find(".po-config-toggle-target");
  const invoiceConfigToggleTarget = outerEl.find(".invoice-config-toggle-target");
  const referenceCustomeFieldTarget = outerEl.find(".reference-custom-field-target");
  const departmentCustomeFieldTarget = outerEl.find(".department-custom-field-target");
  const poCustomeFieldTarget = outerEl.find(".po-custom-field-target");
  const invoiceCustomeFieldTarget = outerEl.find(".invoice-custom-field-target");

  //customFieldSwitchery
  const referenceCustomFieldSwitchery = outerEl.find(".reference-custom-label-switchery");
  const departmentCustomFieldSwitchery = outerEl.find(".department-custom-label-switchery");
  const poCustomFieldSwitchery = outerEl.find(".po-custom-label-switchery");
  const invoiceCustomFieldSwitchery = outerEl.find(".invoice-custom-label-switchery");

  //inputfields
  const referenceCustomLabelField = outerEl.find(".reference-custom-field-input");
  const departmentCustomLabelField = outerEl.find(".department-custom-field-input");
  const poCustomLabelField = outerEl.find(".po-custom-field-input");
  const invoiceCustomLabelField = outerEl.find(".invoice-custom-field-input");

  const defaultItemAllReturns = outerEl.find(".pgp-default-item-all-returns");
  const rmaLiteReferenceDiv = outerEl.find(".pgp-show-rma-lite-reference-div");
  const rmaLiteReference = outerEl.find(".pgp-show-rma-lite-reference");
  const rmaLiteReferenceFieldRequired = outerEl.find(".pgp-rma-lite-reference-required");
  const customizeReferenceLabel = outerEl.find(".pgp-customize-reference-label");
  const customReferenceLabel = $("#pgp-custom-reference-label");
  const rmaLiteReferenceFieldValidation = outerEl.find(".pgp-reference-field-validation");
  const rmaLiteEndPointUrl = $("#pgp-end-point-url");
  const rmaLiteReferenceKey = $("#pgp-name-or-key");
  const rmaLiteReferencePassword = $("#pgp-password");
 
  const hwmrefGroup_1 = outerEl.find(".hwm-ref-group-1");
  const hwmrefGroup_2 = outerEl.find(".hwm-ref-group-2");

  const rscLabelSetting = outerEl.find('.rsc-label-setting');

  //HB-11513
  const warehouseLevelShipmentVisible = outerEl.find(".prp-wl-shipment-visible");
  const warehouseLevelReturnReasonVisible = outerEl.find(".prp-wl-return-reason");
  const prepaidCollectVisible = outerEl.find(".prp-prepaid-collect");
  const billOfLadenVisible = outerEl.find(".prp-bol-entry");
  const rmaNotesVisible = outerEl.find(".prp-rma-notes");
  const warehouseLevelShipmentDiv = outerEl.find(".prp-warehouse-level-shipment-div");
    //HB-11513

  const sendRmaCreationEmailToggler = outerEl.find(".cen-customer-email-notification");
  const sendRmaCreationEmailConfig = outerEl.data("rma-creation-email-config");

  const isRmsOnly = outerEl.data("retailer-is-rms-only");
  const defaultItemAllReturnsDiv = outerEl.find(".pgp-default-item-all-returns-div");

  const returnReasonVisible = outerEl.find(".prp-return-reason");
  const finalSaleFlagVisible = outerEl.find(".prp-final-sale");
  const productWeightVisible = outerEl.find(".prp-product-weight");
  const notesVisible = outerEl.find(".prp-notes");

  //9043 Shipping and Processing fields integration
  const complimentaryReturnShippingVisible = outerEl.find(".sap-complimentary-shipping");
  const overrideShipAddressVisible = outerEl.find(".sap-override-ship-address");
  const overrideShipServiceVisible = outerEl.find(".sap-override-default-ship-address");

  //E-82367 Priority Alert Shipping 
  const priorityAlertShippments = outerEl.find(".sap-priority-alert-shipments");
  // Saturday Delivery
  const expressShipmentsforSaturday = outerEl.find(".sap-express-shipments-saturday");
  const referenceNumberVisible = outerEl.find(".sap-add-ref-number");
  const departmentNumberVisible = outerEl.find(".sap-add-dept-number");
  const invoiceNumberVisible = outerEl.find(".sap-add-invoice-number");
  const poNumberVisible = outerEl.find(".sap-add-po-number");
  const declaredValueVisible = outerEl.find(".sap-add-declared-value");
  const specialCreditProcessingVisible = outerEl.find(".sap-special-credit-processing");
  const display4x4 = outerEl.find(".sap-display-4x4");
  const showPackingSlip = outerEl.find(".sap-show-packing-slip");
  const doNotShowForDefaultItemMerchants = outerEl.find(".do-not-show-for-default-item-merchants");
  const prefedinedRmaPrefixValues = outerEl.data("retailer-predefined-prefix-values");

  const customPredefinedBtnGrpEl = outerEl.find('.custom-predefined-toggler');
  const maxLabelsAllowedEl = outerEl.find('.pgp-max-labels-allowed'); 

  //E-89401 start
  const useRtWindowForRmas = outerEl.find(".pgp-use-rt-window-for-rmas");
  const rtWindowUsageConfigurationsDiv = outerEl.find(".pgp-return-technology-window-usage-configurations-div");
  const rtWindowReturnReasonField = outerEl.find(".pgp-rt-window-show-return-reason");
  const rtWindowAllowPreprintedLabelsField = outerEl.find(".pgp-rt-window-allow-preprinted-labels");
  const rtWindowSerialNumberCaptureField = outerEl.find(".pgp-rt-window-serial-number-capture");
  const rtWindowSerialNumberValidationField = outerEl.find(".pgp-rt-window-serial-number-validation");
  const rtWindowAllowMultipleLabels = outerEl.find("#pgp-rt-window-allow-multiple-labels");
  const rtWindowMaxLabelsAllowed = outerEl.find(".rt-window-max-labels-alwd");
  const rtWindowMaxNumberOfLabels = outerEl.find("#pgp-rt-window-max-labels-allowed");
  const rtWindowPreferencesDiv = outerEl.find(".pgp-show-rt-window-preferences-div");
  //E-89401 end
  let file;
  onLoad();

  function onLoad(){
    if(rmsAuthTokenAvl.length>0 || hcAuthTokenAvl.length>0){
      regenerateAuthTokenBtn.show();
      generateAuthTokenBtn.hide();
      regenerateHCAuthTokenBtn.show();
      generateHCAuthTokenBtn.hide();
    }else{
      regenerateAuthTokenBtn.hide();
      generateAuthTokenBtn.show();
      regenerateHCAuthTokenBtn.hide();
      generateHCAuthTokenBtn.show();
    }
      copyTokenBtn.hide();
      authFailedMsg.hide();
      channelEmptyMsg.hide();
      loadAuthTokenBtn.hide();
      accessTokenDisplayDiv.hide();
       maxLabelsAllowed.hide();
       rtWindowMaxLabelsAllowed.hide();//E-89401
       
       
       referenceConfigToggleTarget.hide();  
       referenceCustomeFieldTarget.hide();     
       departmentConfigToggleTarget.hide();
       departmentCustomeFieldTarget.hide();
       poCustomeFieldTarget.hide();
       poConfigToggleTarget.hide();
       invoiceConfigToggleTarget.hide();
       invoiceCustomeFieldTarget.hide();

       

      hideAndShowBasedOnSubscription();
      loadOrderNumberConfiguration();
      //HB-11513
      loadWarehouseLevelRmaConfiguration();

      let isSwitcheryInstantiated = false;

      if(isRmsOnly){
        loadDefaultItemForReturnsConfig();
        isSwitcheryInstantiated = true;
      }
      
      instantiateSwitchery(referenceShowFieldSwitchery);
      instantiateSwitchery(departmentShowFieldSwitchery);
      instantiateSwitchery(poShowFieldSwitchery);
      instantiateSwitchery(invoiceShowFieldSwitchery);
      
      if(retailerReturnsConfiguration.isFCR == 'On'){
    	// for referenceShow
          if (retailerReturnsConfiguration.referenceShowField){
            referenceShowFieldSwitchery.next(".switchery-default").trigger("click");  
            instantiateSwitchery(referenceRequiredFieldSwitchery);
            instantiateSwitchery(referenceCustomFieldSwitchery);
            referenceConfigToggleTarget.show();
            disableSwitchery(departmentShowFieldSwitchery);
            disableSwitchery(poShowFieldSwitchery);
            disableSwitchery(invoiceShowFieldSwitchery);
            }
          	
        // for departmentShow
          if (retailerReturnsConfiguration.departmentShowField){
            departmentShowFieldSwitchery.next(".switchery-default").trigger("click"); 
            instantiateSwitchery(departmentRequiredFieldSwitchery);
            instantiateSwitchery(departmentCustomFieldSwitchery);
            departmentConfigToggleTarget.show();
            disableSwitchery(referenceShowFieldSwitchery);
            disableSwitchery(poShowFieldSwitchery);
            disableSwitchery(invoiceShowFieldSwitchery);
           }
          
        // for po show
          if (retailerReturnsConfiguration.poShowField){
            poShowFieldSwitchery.next(".switchery-default").trigger("click");  
            instantiateSwitchery(poRequiredFieldSwitchery);
            instantiateSwitchery(poCustomFieldSwitchery);
            poConfigToggleTarget.show();
            disableSwitchery(referenceShowFieldSwitchery);
            disableSwitchery(departmentShowFieldSwitchery);
            disableSwitchery(invoiceShowFieldSwitchery);
           }

               // for Invoice show
          if (retailerReturnsConfiguration.invoiceShowField){
            invoiceShowFieldSwitchery.next(".switchery-default").trigger("click"); 
            instantiateSwitchery(invoiceRequiredFieldSwitchery);
            instantiateSwitchery(invoiceCustomFieldSwitchery);
            invoiceConfigToggleTarget.show();
            disableSwitchery(referenceShowFieldSwitchery);
            disableSwitchery(departmentShowFieldSwitchery);
            disableSwitchery(poShowFieldSwitchery);
           }
          // referencefield
          referenceShowFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
            instantiateSwitchery(referenceRequiredFieldSwitchery);
            instantiateSwitchery(referenceCustomFieldSwitchery);
            referenceConfigToggleTarget.show();
            disableSwitchery(departmentShowFieldSwitchery);
            disableSwitchery(poShowFieldSwitchery);
            disableSwitchery(invoiceShowFieldSwitchery);
            } else {
              setSwitcheryWithoutChange(referenceRequiredFieldSwitchery, false);
              setSwitcheryWithoutChange(referenceCustomFieldSwitchery, false);
              referenceCustomLabelField.val("");
              referenceCustomeFieldTarget.hide();
              referenceConfigToggleTarget.hide();
              enableSwitchery(departmentShowFieldSwitchery);
              enableSwitchery(poShowFieldSwitchery);
              enableSwitchery(invoiceShowFieldSwitchery);
            }
          });
          
          // departmentShowField
          departmentShowFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
               instantiateSwitchery(departmentRequiredFieldSwitchery);
               instantiateSwitchery(departmentCustomFieldSwitchery);
               departmentConfigToggleTarget.show();
               disableSwitchery(referenceShowFieldSwitchery);
               disableSwitchery(poShowFieldSwitchery);
               disableSwitchery(invoiceShowFieldSwitchery);
            } else {
              setSwitcheryWithoutChange(departmentRequiredFieldSwitchery, false);
              setSwitcheryWithoutChange(departmentCustomFieldSwitchery, false);	
              departmentCustomLabelField.val("");
              departmentCustomeFieldTarget.hide();
              departmentConfigToggleTarget.hide();
              enableSwitchery(referenceShowFieldSwitchery);
              enableSwitchery(poShowFieldSwitchery);
              enableSwitchery(invoiceShowFieldSwitchery);
            }
          });
          // po show field
          poShowFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
              instantiateSwitchery(poRequiredFieldSwitchery);
              instantiateSwitchery(poCustomFieldSwitchery);
              poConfigToggleTarget.show();
              disableSwitchery(referenceShowFieldSwitchery);
              disableSwitchery(departmentShowFieldSwitchery);
              disableSwitchery(invoiceShowFieldSwitchery);
            } else {
              setSwitcheryWithoutChange(poRequiredFieldSwitchery, false);
              setSwitcheryWithoutChange(poCustomFieldSwitchery, false);		
              poCustomLabelField.val("");
              poCustomeFieldTarget.hide();
              poConfigToggleTarget.hide();
              enableSwitchery(referenceShowFieldSwitchery);
              enableSwitchery(departmentShowFieldSwitchery);
              enableSwitchery(invoiceShowFieldSwitchery);
            }
          });

          // invoice show field
          invoiceShowFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
              instantiateSwitchery(invoiceRequiredFieldSwitchery);
              instantiateSwitchery(invoiceCustomFieldSwitchery);
              invoiceConfigToggleTarget.show();
              disableSwitchery(referenceShowFieldSwitchery);
              disableSwitchery(departmentShowFieldSwitchery);
              disableSwitchery(poShowFieldSwitchery);
            } else {
              setSwitcheryWithoutChange(invoiceRequiredFieldSwitchery, false);
              setSwitcheryWithoutChange(invoiceCustomFieldSwitchery, false); 	
              invoiceCustomLabelField.val("");
              invoiceCustomeFieldTarget.hide();
              invoiceConfigToggleTarget.hide();
              enableSwitchery(referenceShowFieldSwitchery);
              enableSwitchery(departmentShowFieldSwitchery);
              enableSwitchery(poShowFieldSwitchery);
            }
          });
          // referenceCustomLabel
          referenceCustomFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
              referenceCustomeFieldTarget.show();
            } else {
              referenceCustomLabelField.val(""); 	
              referenceCustomeFieldTarget.hide();
            }
          }); 
          // departmentCustomLabel
          departmentCustomFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
              departmentCustomeFieldTarget.show();
            } else {
              departmentCustomLabelField.val("");	
              departmentCustomeFieldTarget.hide();
            }
          });   
          // poCustomLabel
          poCustomFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
              poCustomeFieldTarget.show();
            } else {
              poCustomLabelField.val("");
              poCustomeFieldTarget.hide();
            }
          }); 
          // invoiceCustomLabel
          invoiceCustomFieldSwitchery.on('change', function () {
            if ($(this).is(":checked")) {
              invoiceCustomeFieldTarget.show();
            } else {
              invoiceCustomLabelField.val("");
              invoiceCustomeFieldTarget.hide();
            }
          }); 
      }else{
    	  
    	  // for referenceShow
          if (retailerReturnsConfiguration.referenceShowField){
            referenceShowFieldSwitchery.next(".switchery-default").trigger("click");  
            instantiateSwitchery(referenceRequiredFieldSwitchery);
            instantiateSwitchery(referenceCustomFieldSwitchery);
            referenceConfigToggleTarget.show();
            }
          // for departmentShow
          if (retailerReturnsConfiguration.departmentShowField){
            departmentShowFieldSwitchery.next(".switchery-default").trigger("click"); 
            instantiateSwitchery(departmentRequiredFieldSwitchery);
            instantiateSwitchery(departmentCustomFieldSwitchery);
            departmentConfigToggleTarget.show();
           }
           
          // for po show
          if (retailerReturnsConfiguration.poShowField){
            poShowFieldSwitchery.next(".switchery-default").trigger("click");  
            instantiateSwitchery(poRequiredFieldSwitchery);
            instantiateSwitchery(poCustomFieldSwitchery);
            poConfigToggleTarget.show();
           }

               // for Invoice show
          if (retailerReturnsConfiguration.invoiceShowField){
            invoiceShowFieldSwitchery.next(".switchery-default").trigger("click"); 
            instantiateSwitchery(invoiceRequiredFieldSwitchery);
            instantiateSwitchery(invoiceCustomFieldSwitchery);
            invoiceConfigToggleTarget.show();
           }

                     
            // referencefield
            referenceShowFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
              instantiateSwitchery(referenceRequiredFieldSwitchery);
              instantiateSwitchery(referenceCustomFieldSwitchery);
                referenceConfigToggleTarget.show();
              } else {
            	setSwitcheryWithoutChange(referenceRequiredFieldSwitchery, false);
                setSwitcheryWithoutChange(referenceCustomFieldSwitchery, false);
                referenceCustomLabelField.val("");
                referenceCustomeFieldTarget.hide();
                referenceConfigToggleTarget.hide();
              }
            });

            // departmentShowField
            departmentShowFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
                 instantiateSwitchery(departmentRequiredFieldSwitchery);
                 instantiateSwitchery(departmentCustomFieldSwitchery);
                 departmentConfigToggleTarget.show();
              } else {
            	setSwitcheryWithoutChange(departmentRequiredFieldSwitchery, false);
                setSwitcheryWithoutChange(departmentCustomFieldSwitchery, false);	
                departmentCustomLabelField.val("");
                departmentCustomeFieldTarget.hide();  
                departmentConfigToggleTarget.hide();
              }
            });
            
            // po show field
            poShowFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
                instantiateSwitchery(poRequiredFieldSwitchery);
                instantiateSwitchery(poCustomFieldSwitchery);
                poConfigToggleTarget.show();
              } else {
            	setSwitcheryWithoutChange(poRequiredFieldSwitchery, false);
                setSwitcheryWithoutChange(poCustomFieldSwitchery, false);		
                poCustomLabelField.val("");
                poCustomeFieldTarget.hide();
                poConfigToggleTarget.hide();
              }
            });

            // invoice show field
            invoiceShowFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
                instantiateSwitchery(invoiceRequiredFieldSwitchery);
                instantiateSwitchery(invoiceCustomFieldSwitchery);
                invoiceConfigToggleTarget.show();
              } else {
            	setSwitcheryWithoutChange(invoiceRequiredFieldSwitchery, false);
                setSwitcheryWithoutChange(invoiceCustomFieldSwitchery, false); 	
                invoiceCustomLabelField.val("");
                invoiceCustomeFieldTarget.hide();
                invoiceConfigToggleTarget.hide();
              }
            });

            // referenceCustomLabel
            referenceCustomFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
                referenceCustomeFieldTarget.show();
              } else {
                referenceCustomLabelField.val("");
                referenceCustomeFieldTarget.hide();
              }
            }); 
            // departmentCustomLabel
            departmentCustomFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
                departmentCustomeFieldTarget.show();
              } else {
            	departmentCustomLabelField.val("");
                departmentCustomeFieldTarget.hide();
              }
            });   
            // poCustomLabel
            poCustomFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
                poCustomeFieldTarget.show();
              } else {
            	poCustomLabelField.val("");
                poCustomeFieldTarget.hide();
              }
            }); 
            // invoiceCustomLabel
            invoiceCustomFieldSwitchery.on('change', function () {
              if ($(this).is(":checked")) {
                invoiceCustomeFieldTarget.show();
              } else {
            	invoiceCustomLabelField.val("");
                invoiceCustomeFieldTarget.hide();
              }
            }); 
      }
      if(retailerReturnsConfiguration.referenceRequiredField) {
          instantiateSwitchery(referenceRequiredFieldSwitchery);
          setSwitchery(referenceRequiredFieldSwitchery, retailerReturnsConfiguration.referenceRequiredField);
        }
        if(retailerReturnsConfiguration.departmentRequiredField) {
          instantiateSwitchery(departmentRequiredFieldSwitchery);
          setSwitchery(departmentRequiredFieldSwitchery, retailerReturnsConfiguration.departmentRequiredField);
        }
        if(retailerReturnsConfiguration.poRequiredField) {
          instantiateSwitchery(poRequiredFieldSwitchery);
          setSwitchery(poRequiredFieldSwitchery, retailerReturnsConfiguration.poRequiredField);
        }
        if(retailerReturnsConfiguration.invoiceRequiredField)   {
          instantiateSwitchery(invoiceRequiredFieldSwitchery);
          setSwitchery(invoiceRequiredFieldSwitchery, retailerReturnsConfiguration.invoiceRequiredField); 
        }
        //for referenceCustom
        if (retailerReturnsConfiguration.referenceCustomLabel){
          instantiateSwitchery(referenceCustomFieldSwitchery);
          referenceCustomFieldSwitchery.next(".switchery-default").trigger("click");  
          referenceCustomeFieldTarget.show();
          }
         //for departmentCustom
         if (retailerReturnsConfiguration.departmentCustomLabel){
          instantiateSwitchery(departmentCustomFieldSwitchery);
          departmentCustomFieldSwitchery.next(".switchery-default").trigger("click");  
          departmentCustomeFieldTarget.show();
         }
         //for pocustom
         if (retailerReturnsConfiguration.poCustomLabel){
          instantiateSwitchery(poCustomFieldSwitchery);
          poCustomFieldSwitchery.next(".switchery-default").trigger("click");  
          poCustomeFieldTarget.show();
         }
        //for invoicecustom
        if (retailerReturnsConfiguration.invoiceCustomLabel){
          instantiateSwitchery(invoiceCustomFieldSwitchery);
          invoiceCustomFieldSwitchery.next(".switchery-default").trigger("click");  
          invoiceCustomeFieldTarget.show();
          }
          //labels
          referenceCustomLabelField.val(retailerReturnsConfiguration.referenceCustomLabelField);
          departmentCustomLabelField.val(retailerReturnsConfiguration.departmentCustomLabelField);
          poCustomLabelField.val(retailerReturnsConfiguration.poCustomLabelField);
          invoiceCustomLabelField.val(retailerReturnsConfiguration.invoiceCustomLabelField);
             
// 10634 start
      if(retailerReturnsConfiguration.defaultItemConfig){
         hideAndShowBasedOnDefaultItemConfig();
        if (!isSwitcheryInstantiated){
          instantiateSwitchery(defaultItemAllReturns);
          defaultItemAllReturns.next(".switchery-default").trigger("click");
        }
        //for return reason
        if (retailerReturnsConfiguration.rmaLiteAllowMultipleLabels){
          instantiateSwitchery(rmaLiteAllowMultipleLabels);
          rmaLiteAllowMultipleLabels.next(".switchery-default").trigger("click");  
          maxLabelsAllowed.show();
        }              
      
         if(retailerReturnsConfiguration.showRmaLiteReturnReason) {
           instantiateSwitchery(rmaLiteReturnReasonField);
           setSwitchery(rmaLiteReturnReasonField, retailerReturnsConfiguration.showRmaLiteReturnReason);
         }
     
          
        
    
         //department end       
       
         rmaLiteReferenceDiv.show();   
         

        if (retailerReturnsConfiguration.showRmaLiteReferenceField){
          instantiateSwitchery(rmaLiteReference);
          rmaLiteReference.next(".switchery-default").trigger("click");
          hwmrefGroup_1.show();

          if (retailerReturnsConfiguration.showCustomReferenceField){
            instantiateSwitchery(customizeReferenceLabel);
            customizeReferenceLabel.next(".switchery-default").trigger("click");  
            hwmrefGroup_2.show();
          }
          if (retailerReturnsConfiguration.rmaLiteReferenceFieldRequired){
            instantiateSwitchery(rmaLiteReferenceFieldRequired);
            rmaLiteReferenceFieldRequired.next(".switchery-default").trigger("click");
          }
			   
          if (retailerReturnsConfiguration.rmaLiteReferenceFieldValidation){
            instantiateSwitchery(rmaLiteReferenceFieldValidation);
            rmaLiteReferenceFieldValidation.next(".switchery-default").trigger("click");
            rmaLiteEndPointUrl.attr("required", "true");
            rmaLiteReferenceKey.attr("required", "true");
            rmaLiteReferencePassword.attr("required", "true");
          }
        }
        customReferenceLabel.val(retailerReturnsConfiguration.rmaLiteReferenceLabel)
        rmaLiteEndPointUrl.val(retailerReturnsConfiguration.rmaLiteReferenceEndPoint)
        rmaLiteReferenceKey.val(retailerReturnsConfiguration.rmaLiteReferenceKey)
        rmaLiteReferencePassword.val(retailerReturnsConfiguration.rmaLiteReferencePassword);    
        
        rmaLiteMaxNumberOfLabels.val(retailerReturnsConfiguration.rmaLiteNumberOfLabels);
        //maxnumber

        

      } else {
        rmaLiteReferenceDiv.hide();     
      }

      rmaLiteReferenceFieldValidation.on("change", function(){
        if ($(this).prop("checked")){  
          if (!rmaLiteReferenceFieldRequired.prop("checked")){
             rmaLiteReferenceFieldRequired.next(".switchery-default").trigger("click");
          }
        }
      });

      defaultItemAllReturns.on("change", function(e){
        var display = (rmaLiteReferenceDiv.css("display") == "none") ? false : true;
        rmaLiteReferenceDiv.toggle(!display);
      });

      rmaLiteReference.on("change", function(e){
        var display =  (hwmrefGroup_1.css("display") == "none") ? false : true;
        hwmrefGroup_1.toggle(!display);  
      });

      customizeReferenceLabel.on("change", function(e){
        var display =  (hwmrefGroup_2.css("display") == "none") ? false : true;
        hwmrefGroup_2.toggle(!display);
      });  
 
      //for maxLabels allowed - E-67370
      rmaLiteAllowMultipleLabels.on('change', function () {
        if ($(this).is(":checked")) {
          maxLabelsAllowed.show();
        } else {
          maxLabelsAllowed.hide();
        }
      });
     
      rmaLiteReferenceFieldValidation.on("change", function(e){

        var required  =  $(this).prop("checked");

        if (required) {
          rmaLiteEndPointUrl.attr("required", required);
          rmaLiteReferenceKey.attr("required", required);
          rmaLiteReferencePassword.attr("required", required);
        }else{
          rmaLiteEndPointUrl.removeAttr("required");
          rmaLiteReferenceKey.removeAttr("required");
          rmaLiteReferencePassword.removeAttr("required");
        }

      });  
      // 10634 end

      //E-89401 start
      rtWindowUsageConfigurationsDiv.show();
      if(retailerReturnsConfiguration.useRtWindowForRmas)
      {
        instantiateSwitchery(useRtWindowForRmas);
        setSwitchery(useRtWindowForRmas, retailerReturnsConfiguration.useRtWindowForRmas);

        if(retailerReturnsConfiguration.rtWindowShowReturnReason) {
          instantiateSwitchery(rtWindowReturnReasonField);
          setSwitchery(rtWindowReturnReasonField, retailerReturnsConfiguration.rtWindowShowReturnReason);
        }
        if(retailerReturnsConfiguration.rtWindowAllowPreprintedLabels) {
          instantiateSwitchery(rtWindowAllowPreprintedLabelsField);
          setSwitchery(rtWindowAllowPreprintedLabelsField, retailerReturnsConfiguration.rtWindowAllowPreprintedLabels);
        }
        if(retailerReturnsConfiguration.rtWindowSerialNumberCapture) {
          instantiateSwitchery(rtWindowSerialNumberCaptureField);
          setSwitchery(rtWindowSerialNumberCaptureField, retailerReturnsConfiguration.rtWindowSerialNumberCapture);
        }
        if(retailerReturnsConfiguration.rtWindowSerialNumberValidation) {
          instantiateSwitchery(rtWindowSerialNumberValidationField);
          setSwitchery(rtWindowSerialNumberValidationField, retailerReturnsConfiguration.rtWindowSerialNumberValidation);
        }
        if (retailerReturnsConfiguration.rtWindowAllowMultipleLabels){
          instantiateSwitchery(rtWindowAllowMultipleLabels);
          rtWindowAllowMultipleLabels.next(".switchery-default").trigger("click");  
          rtWindowMaxLabelsAllowed.show();
        }

        rtWindowMaxNumberOfLabels.val(retailerReturnsConfiguration.rtWindowNumberOfLabels);
      }
      else
      {
        rtWindowPreferencesDiv.hide();
      }
      useRtWindowForRmas.on('change', function(e){
        if ($(this).is(":checked")) {
        rtWindowPreferencesDiv.show();
        } else {
        rtWindowPreferencesDiv.hide();
        }
        });

      rtWindowAllowMultipleLabels.on('change', function () {
        if ($(this).is(":checked")) {
          rtWindowMaxLabelsAllowed.show();
        } else {
          rtWindowMaxLabelsAllowed.hide();
        }
      });
      rtWindowSerialNumberCaptureField.on('change', function () {
        if ($(this).is(":checked")) {
          setSwitchery(rtWindowSerialNumberValidationField, false);
        }
      });
      rtWindowSerialNumberValidationField.on('change', function () {
        if ($(this).is(":checked")) {
          setSwitchery(rtWindowSerialNumberCaptureField, false);
        }
      });   
      //E-89401 end

      loadRmaCreationEmailConfig();
      loadManualRmaProductCaptures();
      loadShippingAndProcessingCaptures();
      loadRmaPredefinedPrefixConfigs();

      customRmaPrefixField.hide();
      customRmaPredefinedField.hide();
      initializeRmaPrefixBtns();
  }


 function initializeRmaPrefixBtns(){
    const customPredefinedBtnGrp = new QuickBtnGroup(customPredefinedBtnGrpEl, {
      distributeWidth: true,
      onBtnClick: function({btn, btnKey}){
        if(btnKey == 'custom'){
          customRmaPrefixField.show();
          customRmaPredefinedField.hide();

        } else{
          customRmaPredefinedField.show();
          customRmaPrefixField.hide();
        }
      }
    });
    customPredefinedBtnGrp.init();

    setRmaPrefixData(customPredefinedBtnGrp);
  }

  function setRmaPrefixData(customPredefinedBtnGrp){
    if(retailerReturnsConfiguration.rmaPrefixType == 'predefined'){
      customRmaPredefinedField.show();
      customRmaPrefixField.hide();
      customPredefinedBtnGrp.activateBtnViaKey('predefined');
      $("#sgr-prefix-predefined option").each(function () {
        if ($(this).html() == retailerReturnsConfiguration.rmaPrefix) {
            $(this).attr("selected", "selected");
            return;
        }
      });
    }else{
      customRmaPrefixField.show();
      customRmaPredefinedField.hide();
      customPredefinedBtnGrp.activateBtnViaKey('custom');
      sgrPrefix.val(retailerReturnsConfiguration.rmaPrefix);
    }
  }

  // Define color picker params
  const colorPickerObj = {
    input: swatchInput,
    format: 'hex',
    customClass: "q-color-picker"
  };

   // var for color picker, defined on page load
  let colorPicker;

  const previewImage = $('.banner-preview-image');
  function init(){
    colorPicker = colorPickerLink.colorpicker(colorPickerObj);
    bindEvents();
    enforceInputMasks();

    file = quickFileUploader(fileUploaderEl,
      {
        afterReadFile: function (e, result) {
          previewImage
            .attr('src', e.target.result)
            .addClass("banner-preview-image");
            hideShowPreview();
        },
        afterRemoveFile: function(){
          previewImage.attr('src','');
          hideShowPreview();
        }
      }
    );
    if(scRmaService.val() == "S"){
      systemGeneratedRmaConfig.show();
      retailerSuppliedRmaConfig.hide();
    }else if(scRmaService.val() == "R"){
      systemGeneratedRmaConfig.hide();
      retailerSuppliedRmaConfig.show();
    }
  }
   function enforceInputMasks(){
    // NOTE: jasny bootstrap docs say that "w" is for alphanumaeric characters, but in application here, "*" somehow acts as alphanumeric
    swatchInput.inputmask({
      mask: "#******"
    });
  }

  function bindEvents(){
    colorPicker.on('changeColor', editSwatchInputVal);
    swatchInput.on('change', editColorPickerVal);
  }

  function editSwatchInputVal(e){
    const hexValue = e.color.toString('hex');
    swatchInput.val(hexValue);
    hideShowPreview();

    // NOTE: color picker val will change either way, so this function only needs to be called once from here
    editSampleColorEls(hexValue);
  }

  // NOTE: this doesn't quite work yet as the color picker defaults to #000000 hex instead of empty
  function editColorPickerVal(){
    const swatchColor = swatchInput.val();
    colorPicker.colorpicker('setValue', swatchColor);
    hideShowPreview();
  }

  function hideShowPreview(){
    if(isPresent(swatchInput.val()) || isPresent($(previewImage).attr('src')) ){
      retailerBannerPreview.hide();
      bannerEl.show();
    }else{
      retailerBannerPreview.show();
      bannerEl.hide();
    }
  }

  function editSampleColorEls(color){
    swatchEl.css({backgroundColor: color});
    bannerEl.css({backgroundColor: color});
  }

  const bannerDefault = outerEl.find(".sc-default-fedex-banner");
  const bannerConfigSection = outerEl.find(".retailer-banner-config");
  bannerDefault.on('change', function(){
    if($(this).is(":checked")){
      retailerBannerConfigSection.hide();
    }else{
      retailerBannerConfigSection.show();
    }
  });

  const logiOrientation = $(".sc-logo-orientation");

  logiOrientation.on('change',function(){
    bannerEl.attr('align',this.value);
    retailerBannerPreview.hide();
    bannerEl.show();
  });

  scRmaService.on('change', function(){

    let helpText =  $(this).closest('div').siblings('div').find('.dropdown-hint-target');

    if(this.value == 'S'){
      helpText.text(`We'll generate the RMA Number.`);
      systemGeneratedRmaConfig.show();
      retailerSuppliedRmaConfig.hide();
    }else{
       helpText.text(`Retailer will supply the RMA number.`);
       systemGeneratedRmaConfig.hide();
       retailerSuppliedRmaConfig.show();
    }
  });

  scShippingService.on('change', function(){
    let helpText =  $(this).closest('div').siblings('div').find('.dropdown-hint-target');

    if(this.value == 'EX'){
      helpText.html(`<div>All returns will be shipping via Express Shipping.</div>`);
    }else{
       helpText.html(`<div class='q-marg-vert-xs'>We'll calculate the shipping service.</div>`);
    }
  });

  rscLabelSetting.on('change', function(){

    let helpText =  $(this).closest('div').siblings('div').find('.dropdown-hint-target');

    if(this.value == 'OPSB'){
      helpText.html(`<div>When returning multiple products at time, each box and label will only contain a single product.</div>`);
    }else{
       helpText.html(`<div class='q-marg-vert-xs'>Each return can only contain a single box that can hold multiple products.</div>`);
    }
  });

  copyTokenBtn.on('click', function(){
      accessTokenVal.select();
      document.execCommand('copy');
    });

    regenerateAuthTokenBtn.on('click',function(){
      if(returnChannelName.val() == 0){
        channelEmptyMsg.show();
        return;
      }
      channelEmptyMsg.hide();
      regenerateAuthTokenBtn.hide();
      copyTokenBtn.hide();
      loadAuthTokenBtn.show();
      $.ajax({
          url: regenerateAuthTokenBtn.data('token-url'),
          type: 'POST',
          dataType: 'json',
          data:[],
          success: function (resp) {
              if (resp.data && resp.data != null && resp.data != 'null') {
                accessTokenDisplayDiv.show();
                accessTokenVal.text(resp.data);
                accessTokenVal.prop('readonly', true);
                regenerateAuthTokenBtn.show();
                copyTokenBtn.show();
                loadAuthTokenBtn.hide();
                generateAuthTokenBtn.hide();
              } else{
                authFailedMsg.show();
                regenerateAuthTokenBtn.hide();
                copyTokenBtn.hide();
                loadAuthTokenBtn.hide();
                generateAuthTokenBtn.show();
              }
          },
          error: function (xhr, status, error) {
            authFailedMsg.show();
            regenerateAuthTokenBtn.hide();
            copyTokenBtn.hide();
            loadAuthTokenBtn.hide();
            generateAuthTokenBtn.show();
          }
      });
    });

    //addAnthChannelBtn.on('click', function(){
    //  duplicateTokenAuthDiv.clone().insertAfter(duplicateTokenAuthDiv);

    //});

    generateAuthTokenBtn.on('click', function(){
      if(returnChannelName.val() == 0){
        channelEmptyMsg.show();
        return;
      }
      channelEmptyMsg.hide();
      generateAuthTokenBtn.hide();
      loadAuthTokenBtn.show();
      $.ajax({
          url: generateAuthTokenBtn.data('token-url'),
          type: 'POST',
          dataType: 'json',
          data:[],
          success: function (resp) {
              if (resp.data && resp.data != null && resp.data != 'null') {
                accessTokenDisplayDiv.show();
                accessTokenVal.text(resp.data);
                accessTokenVal.prop('readonly', true);
                regenerateAuthTokenBtn.show();
                copyTokenBtn.show();
                loadAuthTokenBtn.hide();
                generateAuthTokenBtn.hide();
              } else{
                authFailedMsg.show();
                //regenerateAuthTokenBtn.hide();
              //  copyTokenBtn.hide();
                loadAuthTokenBtn.hide();
                //generateAuthTokenBtn.show();
              }
          },
          error: function (xhr, status, error) {
            authFailedMsg.show();
            //regenerateAuthTokenBtn.hide();
            //copyTokenBtn.hide();
            loadAuthTokenBtn.hide();
            //generateAuthTokenBtn.show();
          }
      });
  });

  regenerateHCAuthTokenBtn.on('click',function(){
    if(returnChannelName.val() == 0){
      channelEmptyMsg.show();
      return;
    }
    var partnerId = $('#returnChannelName :selected').val();
    channelEmptyMsg.hide();
    regenerateHCAuthTokenBtn.hide();
    copyTokenBtn.hide();
    loadAuthTokenBtn.show();
    $.ajax({
        url: regenerateHCAuthTokenBtn.data('token-url'),
        type: 'POST',
        dataType: 'json',
        data:({
  			 partnerId : partnerId
  			}),
        success: function (resp) {
            if (resp.data && resp.data != null && resp.data != 'null') {
              accessTokenDisplayDiv.show();
              accessTokenVal.text(resp.data);
              accessTokenVal.prop('readonly', true);
              regenerateHCAuthTokenBtn.show();
              copyTokenBtn.show();
              loadAuthTokenBtn.hide();
              generateHCAuthTokenBtn.hide();
            } else{
              authFailedMsg.show();
              regenerateHCAuthTokenBtn.hide();
              copyTokenBtn.hide();
              loadAuthTokenBtn.hide();
              generateHCAuthTokenBtn.show();
            }
        },
        error: function (xhr, status, error) {
          authFailedMsg.show();
          regenerateHCAuthTokenBtn.hide();
          copyTokenBtn.hide();
          loadAuthTokenBtn.hide();
          generateHCAuthTokenBtn.show();
        }
    });
  });

  //addAnthChannelBtn.on('click', function(){
  //  duplicateTokenAuthDiv.clone().insertAfter(duplicateTokenAuthDiv);

  //});

  generateHCAuthTokenBtn.on('click', function(){
    if(returnChannelName.val() == 0){
      channelEmptyMsg.show();
      return;
    }
    var partnerId = $('#returnChannelName :selected').val();
    channelEmptyMsg.hide();
    generateHCAuthTokenBtn.hide();
    loadAuthTokenBtn.show();
    $.ajax({
        url: generateHCAuthTokenBtn.data('token-url'),
        type: 'POST',
        dataType: 'json',
        data:({
  			 partnerId : partnerId
  			}),
        success: function (resp) {
            if (resp.data && resp.data != null && resp.data != 'null') {
              accessTokenDisplayDiv.show();
              accessTokenVal.text(resp.data);
              accessTokenVal.prop('readonly', true);
              regenerateHCAuthTokenBtn.show();
              copyTokenBtn.show();
              loadAuthTokenBtn.hide();
              generateHCAuthTokenBtn.hide();
            } else{
              authFailedMsg.show();
            //  regenerateHCAuthTokenBtn.hide();
            //  copyTokenBtn.hide();
              loadAuthTokenBtn.hide();
            //  generateHCAuthTokenBtn.show();
            }
        },
        error: function (xhr, status, error) {
          authFailedMsg.show();
        //  regenerateHCAuthTokenBtn.hide();
        //  copyTokenBtn.hide();
          loadAuthTokenBtn.hide();
        //  generateHCAuthTokenBtn.show();
        }
    });
});

  let retailerServiceConfigForm = outerEl.find(".retailer-service-configuration-form");
  let retailerServiceConfigSubmitLink = outerEl.find(".save-service-config-edits");

  bindHardSubmit({
    form: retailerServiceConfigForm,
    links: retailerServiceConfigSubmitLink
  });

  if(!$(bannerConfigSection).data("default-value") || $(bannerConfigSection).data("default-value") ==  "on"){
    bannerConfigSection.hide();
  }else{
    bannerConfigSection.show();
  }

  retailerServiceConfigForm.validate({
    errorPlacement: function(error, element) {

      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    },

    // Place all your validation rules here!!!
    rules: {
      "sc-logo-img-hidden": {
        maxFileSizeBytes: 200000000
      },
      "sgr-prefix" : {
        regex: "^[a-zA-Z0-9_-]*$"
      },
      "rsa-prefix" : {
       regex: "^[a-zA-Z0-9_-]*$"
      },
      "sgr-number-length":{
        max:10,
        min:5
      },
       "sgr-starting-number":{
        startNumberLimit: true,
        min: currentEntityNumber
      },
      "pgp-max-labels-allowed":{  //E-67370
        max:5,
        min:1
      },
      "pgp-rt-window-max-labels-allowed":{//E-89401
        max:5,
        min:1
      }
    },
    messages: {
      "sgr-number-length": {
        min: "Length must be longer than 5 and less than 10.",
        max: "Length must be longer than 5 and less than 10."
      },
      "pgp-max-labels-allowed":{ //E-67370
        max: "Number must be between 1 and 5.",
        min: "0 cannot be entered."
      },
      "pgp-rt-window-max-labels-allowed":{ //E-89401
        max: "Number must be between 1 and 5.",
        min: "0 cannot be entered."
      }
    }
  });

  $.validator.addMethod(
    "regex",
    function(value, element, regexp) {

        var check = false;
        var re = new RegExp(regexp);
        return this.optional(element) || re.test(value);
    },
    "A character has been added that is not valid."
  );

  $.validator.addMethod(
    "startNumberLimit",
    function(value, element) {
      let startNumberValue= startNumberLength.val();
      if(isPresent(startNumberValue)){
        return startNumberValue >= value.length;
      }else{
        return true;
      }

    },
    "Starting number length must not exceed rma number length."
  );
 
  // NOTE: when instantiating this init function from a separate js file, please see consumerReturnsView stub for example, or ask a UI dev for an example

  init();
  hideShowPreview();

  retailerServiceConfigForm.on('submit', function(e){
    e.preventDefault();
    if(retailerServiceConfigForm.valid()){
      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: 'Submit Retailer Configuration',
        confirmModalBody: '<div class="q-pad-all-xl">By submitting this configuration, the service configuration information will be saved for current retailer.</div>',
        confirmModalBtnText: 'Submit',
         onConfirmClick: function() {
             submitModalFlow.showLoadingModal();
             let formData = new FormData(retailerServiceConfigForm[0]);
                   $.ajax({
                    url: retailerServiceConfigForm.attr('action'),
                    type: 'POST',
                    processData:false,
                    contentType:false,
                    data: formData,
                    success: function(resp){
                      submitModalFlow.showSuccessModal();
                      setTimeout(function() {
                        location.href = serviceConfiguration;
                      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                    },
                    error: function(error){
                     submitModalFlow.showFailureModal();
                    }
                  });
        }

      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  });

  function loadOrderNumberConfiguration(){
    instantiateSwitchery(orderNumberVisible);
    setSwitchery(orderNumberVisible, retailerReturnsConfiguration.originalOrderNumberVisible);

    instantiateSwitchery(orderNumberMandatory);
    setSwitchery(orderNumberMandatory, retailerReturnsConfiguration.originalOrderNumberMandatory);

    if(retailerReturnsConfiguration.originalOrderNumberVisible){
      orderNumberMandatoryDiv.show();
    }else{
      setSwitchery(orderNumberVisible, false);
      orderNumberMandatoryDiv.hide();
    }
  }

  //HB-11513
  function loadWarehouseLevelRmaConfiguration(){
    instantiateSwitchery(warehouseLevelShipmentVisible);
    setSwitchery(warehouseLevelShipmentVisible, retailerReturnsConfiguration.warehouseLevelRmasVisible);

    instantiateSwitchery(warehouseLevelReturnReasonVisible);
    setSwitchery(warehouseLevelReturnReasonVisible, retailerReturnsConfiguration.reasonForReturnVisible);

    instantiateSwitchery(prepaidCollectVisible);
    setSwitchery(prepaidCollectVisible, retailerReturnsConfiguration.prepaidCollectVisible);

    instantiateSwitchery(billOfLadenVisible);
    setSwitchery(billOfLadenVisible, retailerReturnsConfiguration.billOfLadenVisible);

    instantiateSwitchery(rmaNotesVisible);
    setSwitchery(rmaNotesVisible, retailerReturnsConfiguration.rmaNotesVisible);

    if(retailerReturnsConfiguration.warehouseLevelRmasVisible){
      warehouseLevelShipmentDiv.show();
    }else{
      setSwitchery(warehouseLevelShipmentVisible, false);
      warehouseLevelShipmentDiv.hide();
    }
  }

  function loadDefaultItemForReturnsConfig(){

    instantiateSwitchery(defaultItemAllReturns);
    setSwitchery(defaultItemAllReturns, retailerReturnsConfiguration.defaultItemConfig); 
      
 }

  function loadRmaCreationEmailConfig(){
    instantiateSwitchery(sendRmaCreationEmailToggler);
    setSwitchery(sendRmaCreationEmailToggler, sendRmaCreationEmailConfig);
  }

  function hideAndShowBasedOnSubscription(){
    if(isRmsOnly){
      defaultItemAllReturnsDiv.show();
    }else{
      defaultItemAllReturnsDiv.hide();
    }
  }

  function hideAndShowBasedOnDefaultItemConfig(){
    
    if(retailerReturnsConfiguration.defaultItemConfig){
      doNotShowForDefaultItemMerchants.show(); 
    }else{
      doNotShowForDefaultItemMerchants.show();
    }

  }

  function loadManualRmaProductCaptures(){
    instantiateSwitchery(returnReasonVisible);
    setSwitchery(returnReasonVisible, retailerReturnsConfiguration.returnReasonVisible);

    instantiateSwitchery(finalSaleFlagVisible);
    setSwitchery(finalSaleFlagVisible, retailerReturnsConfiguration.finalSaleFlagVisible);

    instantiateSwitchery(productWeightVisible);
    setSwitchery(productWeightVisible, retailerReturnsConfiguration.productWeightVisible);

    instantiateSwitchery(notesVisible);
    setSwitchery(notesVisible, retailerReturnsConfiguration.notesVisible);
  }
  
  //9043 Shipping and Processing Fields integration post Edit
  function loadShippingAndProcessingCaptures(){

    instantiateSwitchery(complimentaryReturnShippingVisible);
    setSwitchery(complimentaryReturnShippingVisible, retailerReturnsConfiguration.complimentaryReturnShippingVisible);

    instantiateSwitchery(overrideShipAddressVisible);
    setSwitchery(overrideShipAddressVisible, retailerReturnsConfiguration.overrideShipAddressVisible);

    instantiateSwitchery(overrideShipServiceVisible);
    setSwitchery(overrideShipServiceVisible, retailerReturnsConfiguration.overrideShipServiceVisible);

    //E-82367 Priority Alert Shipping
    instantiateSwitchery(priorityAlertShippments);
    setSwitchery(priorityAlertShippments, retailerReturnsConfiguration.priorityAlertShippments);
    // Saturday Delivery
    instantiateSwitchery(expressShipmentsforSaturday);
    setSwitchery(expressShipmentsforSaturday, retailerReturnsConfiguration.expressShipmentsforSaturday);
    
    instantiateSwitchery(declaredValueVisible);
    setSwitchery(declaredValueVisible, retailerReturnsConfiguration.declaredValueVisible);

    instantiateSwitchery(specialCreditProcessingVisible);
    setSwitchery(specialCreditProcessingVisible, retailerReturnsConfiguration.specialCreditProcessingVisible);

    instantiateSwitchery(display4x4);
    setSwitchery(display4x4, retailerReturnsConfiguration.display4x4);

    instantiateSwitchery(showPackingSlip);
    setSwitchery(showPackingSlip, retailerReturnsConfiguration.showPackingSlip);
  }

  function loadRmaPredefinedPrefixConfigs(){
    setOptionsForSelect({
      selectElement: sgrPrefixPredefined,
      list: prefedinedRmaPrefixValues,
      valueDataKey: "cdmValue",
      textDataKey: "cdmMeaning"
    });
  } 

}



// WEBPACK FOOTER //
// ./src/pages/merchantConfig/merchantConfigManage/manage.js